import { render, staticRenderFns } from "./SalaryAdd.vue?vue&type=template&id=751ea377&"
import script from "./SalaryAdd.vue?vue&type=script&lang=js&"
export * from "./SalaryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports